import { render, staticRenderFns } from "./ParametricRootFolderCardOptions.vue?vue&type=template&id=e0641e30&scoped=true&"
import script from "./ParametricRootFolderCardOptions.vue?vue&type=script&lang=js&"
export * from "./ParametricRootFolderCardOptions.vue?vue&type=script&lang=js&"
import style0 from "./ParametricRootFolderCardOptions.vue?vue&type=style&index=0&id=e0641e30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0641e30",
  null
  
)

export default component.exports